import React, { useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';
import ErrorMessage from '@components/Error/ErrorMessage';
import { setCountryList, setUserRole } from '@store/reducers/auth/signupSlice';
import { MdOutlineModeEdit } from 'react-icons/md';
import { checkUserExists, fetchCountries } from '@utils/utils';
import {
    CHANGE_PASSWORD_PATH,
    PROFILE_RESET_PASSWORD_PATH,
} from '@constants/routes';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import {
    MOBILE_NUMBER_PATTERN,
    MOBILE_NUMBER_TITLE,
    PINCODE_MAXIMUM_LENGTH,
    PINCODE_MINIMUM_LENGTH,
    PINCODE_PATTERN,
    PINCODE_TITLE,
    MOBILE_NUMBER_MIN_LENGTH,
    MOBILE_NUMBER_MAX_LENGTH,
    NAME_TEXT_MIN_LENGTH,
    NAME_TEXT_MAX_LENGTH,
    NAME_TEXT_PATTERN,
    NAME_TEXT_TITLE,
    HOSPITAL_NAME_TEXT_TITLE,
    HOSPITAL_NAME_PATTERN,
    GST_NUMBER_MAX_LENGTH,
    GST_NUMBER_MIN_LENGTH,
    GST_NUMBER_TITLE,
    GST_NUMBER_PATTERN,
    ADDRESS_MAX_LENGTH,
} from '@constants/form';
import {
    setLoggedInUserName,
    setLoggedInUserEmail,
    setLoggedInUserDeviceID,
    setLoggedInUserMobileNumber,
    setLoggedInUserAddressOne,
    setLoggedInHospitalGstNo,
    setLoggedInHospitalBranch,
    setLoggedInHospitalName,
    setLoggedInUserAddressTwo,
    setLoggedInUserCity,
    setLoggedInUserState,
    setLoggedInUserCountry,
    setLoggedInUserPincode,
    setUserTableUuid,
    setHospitalTableUuid,
    setLoggedInUserTenantID,
    setProfileImageUrl,
} from '@store/reducers/auth/loginSlice';
import {
    adminCreateUser,
    adminUpdateUser,
    deleteS3Object,
    updateUser,
} from '@utils/utils';
import { HOSPITAL, INDIVIDUAL, NURSE, ADMIN } from '@constants/constants';
import { DEFAULT_PROFILE_SRC } from '@constants/images';
import LoadingSpinner from '@components/Spinner';
import { fetchStates, fetchCountryId } from '@utils/utils';
import {
    setStateList,
    setFileMetadata,
} from '@store/reducers/auth/signupSlice';
import {
    DEVICE_ID,
    TENANT_ID,
    USER_MOBILE_NUMBER,
    USER_NAME,
} from '@constants/cognitoAttributes';
import {
    S3Client,
    PutObjectCommand,
    ObjectCannedACL,
    ServerSideEncryption,
    GetObjectCommand,
} from '@aws-sdk/client-s3';
import { addUUIDSegmentToFilename, getUserAttributes } from '@utils/authUtils';
import { s3Client } from '@utils/awsClients';
import awsConfig from '../amplifyconfiguration.json';
import Swal from 'sweetalert2';
import { generateUniqueTimestamp, getDataUsingHospitalId } from '@utils/sharedUtils';
import {
    HOSPITALS_TABLE,
    HOSPITAL_INFO_TABLE,
    USER_INFO_TABLE,
} from '@constants/dynamoDBTableName';
const MySwal = Swal;
type EditModeFields =
    | 'name'
    | 'email'
    | 'mobileNumber'
    | 'addressOne'
    | 'hospitalBranch'
    | 'hospitalName'
    | 'gstNo'
    | 'city'
    | 'addressTwo'
    | 'state'
    | 'country'
    | 'pincode';
const Profile: React.FC = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);
    // const [profileImage, setProfileImage] = useState<string>(DEFAULT_PROFILE_SRC);

    const fileInputRef = useRef<HTMLInputElement | null>(null);
    const [rerender, setRerender] = useState(false);
    const countryList = useAppSelector((state) => state.signup.countryList);
    const stateList = useAppSelector((state) => state.signup.stateList);
    // const formattedDateTime = new Date().toISOString();
    const formattedDateTime = generateUniqueTimestamp();
    const loggedInUserName = useAppSelector(
        (state) => state.login.loggedInUserName
    );
    const loggedInUserEmail = useAppSelector(
        (state) => state.login.loggedInUserEmail
    );
    const loggedInUserDeviceID = useAppSelector(
        (state) => state.login.loggedInUserDeviceID
    );
    const loggedInUserMobilenumber = useAppSelector(
        (state) => state.login.loggedInUserMobilenumber
    );
    const loggedInUserAddressOne = useAppSelector(
        (state) => state.login.loggedInUserAddressOne
    );
    const loggedInUserAddressTwo = useAppSelector(
        (state) => state.login.loggedInUserAddressTwo
    );
    const loggedInUserCity = useAppSelector(
        (state) => state.login.loggedInUserCity
    );
    const loggedInUserCountry = useAppSelector(
        (state) => state.login.loggedInUserCountry
    );
    const loggedInUserState = useAppSelector(
        (state) => state.login.loggedInUserState
    );
    const loggedInUserPincode = useAppSelector(
        (state) => state.login.loggedInUserPincode
    );
    const loggedInHospitalGstNo = useAppSelector(
        (state) => state.login.loggedInHospitalGstNo
    );
    const loggedInHospitalBranch = useAppSelector(
        (state) => state.login.loggedInHospitalBranch
    );
    const loggedInHospitalName = useAppSelector(
        (state) => state.login.loggedInHospitalName
    );
    const hospitalTableUuid = useAppSelector(
        (state) => state.login.hospitalTableUuid
    );
    const profileImageName = useAppSelector(
        (state) => state.login.profileImageName
    );
    const [userName, setUserName] = useState<string>(loggedInUserName);
    const [userEmail, setUserEmail] = useState<string>(loggedInUserEmail);
    const [pincode, setPincode] = useState<string>(loggedInUserPincode);
    const [hospitalName, setHospitalName] =
        useState<string>(loggedInHospitalName);
    const [deviceID, setDeviceID] = useState<string>(loggedInUserDeviceID);
    const [mobilenumber, setMobilenumber] = useState<string>(
        loggedInUserMobilenumber
    );
    const [addressOne, setAddressOne] = useState<string>(
        loggedInUserAddressOne
    );
    const [addressTwo, setAddressTwo] = useState<string>(
        loggedInUserAddressTwo
    );
    const [city, setCity] = useState<string>(loggedInUserCity);
    const [userCountry, setUserCountry] = useState<string>(loggedInUserCountry);
    const [userState, setUserState] = useState<string>(loggedInUserState);
    const [hospitalGstNo, setHospitalGstNo] = useState<string>(
        loggedInHospitalGstNo
    );
    const loggedInUserCognitoUuid = useAppSelector(
        (state) => state.login.loggedInUserCognitoUuid
    );
    const userTableUuid = useAppSelector((state) => state.login.userTableUuid);
    const userRole = useAppSelector((state) => state.login.loggedInUserRole);
    const loggedInUserTenantID = useAppSelector(
        (state) => state.login.loggedInUserTenantID
    );
    const loggedInHospitalUuId = useAppSelector(
        (state) => state.login.loggedInHospitalUuId
    );
    const loggedInHospitalId = useAppSelector(
        (state) => state.login.loggedInHospitalId
    );
    const oldProfileImageName = useAppSelector(
        (state) => state.login.oldProfileImageName
    );
    const [filename, setFileName] = useState<string | null>(profileImageName);
    const [profilePictureName, setProfilePictureName] = useState<string>('');
    const [profilePictureUrl, setProfilePictureUrl] = useState<string>('');
    const [profilePictureType, setProfilePictureType] = useState<string>('');

    // let userRole = 'nurse';
    const onBackClick = () => {
        navigate(-1);
    };

    const handleFetchStates = async (countryId: string) => {
        const result = await fetchStates(countryId);
        if (result.states) {
            dispatch(setStateList(result.states));
        } else if (result.error) {
            // Handle error message
            console.error('Error fetching states:', result.error);
        }
    };
    const handleMobileNumberChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = event.target.value;
        // Allow only numbers (0-9)
        if (/^\d*$/.test(value)) {
            setMobilenumber(value);
        }

        // dispatch(setMobileNumber(event.target.value));
    };
    const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setUserEmail(event.target.value);
    };

    const handleUserNameChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setUserName(event.target.value);
    };

    const handleChangePassword = () => {
        navigate(PROFILE_RESET_PASSWORD_PATH);
    };

    const handleAddressOneChange = (
        event: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        setAddressOne(event.target.value);
    };

    const handleAddressTwoChange = (
        event: React.ChangeEvent<HTMLTextAreaElement>
    ) => {
        setAddressTwo(event.target.value);
    };

    const handleCityChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;
        // Only allow alphabetic characters (letters) using regex
        const sanitizedValue = inputValue.replace(/[^A-Za-z]/g, '');
        setCity(sanitizedValue);
    };

    const handleStateChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        setUserState(event.target.value);
    };
    
    useEffect(() => {
        // Only fetch if country list is empty
        if (countryList.length === 0) {
            handleFetchCountryList();
        }
    }, []);

    // Fetch states on load if country has a value (for edit pages)
    useEffect(() => {
        const fetchStatesForCountry = async () => {
            if (loggedInUserCountry && countryList.length > 0) {
                const selectedCountry = countryList.find(
                    (c) => c.name === loggedInUserCountry
                );
                if (selectedCountry) {
                    await handleFetchStates(selectedCountry.code);
                }
            }
        };
        fetchStatesForCountry();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInUserCountry, countryList]);

    useEffect(() => {
        // Set initial state values
        setHospitalName(loggedInHospitalName);
        setPincode(loggedInUserPincode);
        setUserName(loggedInUserName);
        setDeviceID(loggedInUserDeviceID);
        setMobilenumber(loggedInUserMobilenumber);
        setAddressOne(loggedInUserAddressOne);
        setAddressTwo(loggedInUserAddressTwo);
        setCity(loggedInUserCity);
        setUserCountry(loggedInUserCountry);
        setUserState(loggedInUserState);
        setHospitalGstNo(loggedInHospitalGstNo);
    }, [
        userCountry,
        loggedInUserName,
        loggedInUserPincode,
        loggedInHospitalName,
        loggedInUserDeviceID,
        loggedInUserMobilenumber,
        loggedInUserAddressOne,
        loggedInUserAddressTwo,
        loggedInUserCity,
        loggedInUserCountry,
        loggedInUserState,
        loggedInHospitalGstNo,
    ]);

    // Fetch hospital name for nurse users
    useEffect(() => {
        const fetchHospitalNameForNurse = async () => {
            if (
                userRole.toLowerCase() === NURSE.toLowerCase() &&
                loggedInHospitalId &&
                !loggedInHospitalName
            ) {
                try {
                    const hospitalData = await getDataUsingHospitalId(
                        HOSPITALS_TABLE,
                        loggedInHospitalId
                    );
                    if (
                        hospitalData?.Items &&
                        hospitalData.Items.length > 0
                    ) {
                        const hospitalItem = hospitalData.Items[0];
                        const hospitalName =
                            hospitalItem?.hospital_name?.S ?? '';
                        if (hospitalName) {
                            dispatch(setLoggedInHospitalName(hospitalName));
                            setHospitalName(hospitalName);
                        }
                    }
                } catch (error) {
                    console.error(
                        'Error fetching hospital name for nurse:',
                        error
                    );
                }
            }
        };
        fetchHospitalNameForNurse();
    }, [userRole, loggedInHospitalId, loggedInHospitalName, dispatch]);

    const handleFetchCountryList = async () => {
        const list = await fetchCountries();
        if (list.countries) {
            dispatch(setCountryList(list.countries));
        } else if (list.error) {
            console.error('Error fetching countries:', list.error);
        }
    };

    const handleCountryChange = (
        event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const selectedCountry = countryList.find(
            (c) => c.name === event.target.value
        );
        if (selectedCountry) {
            setUserCountry(selectedCountry.name);
            setUserState(''); // Clear state when country changes
            dispatch(setStateList([])); // Clear state list
            handleFetchStates(selectedCountry.code); // Fetch states for the selected country
        } else {
            setUserCountry(event.target.value);
            setUserState(''); // Clear state when country changes
            dispatch(setStateList([])); // Clear state list
        }
    };
    const handleHospitalName = (event: React.ChangeEvent<HTMLInputElement>) => {
        setHospitalName(event.target.value);
    };
    const handleHospitalGstChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        // dispatch(setHospitalGST(event.target.value));
        const inputValue = event.target.value.toUpperCase();
        // Only allow alphanumeric characters using regex
        const sanitizedValue = inputValue.replace(/[^A-Za-z0-9]/g, '');
        setHospitalGstNo(sanitizedValue);
        // Check if the value matches the GST number pattern
        if (!/^[0-9A-Z]{15}$/.test(sanitizedValue)) {
            setError(GST_NUMBER_TITLE);
        } else {
            setError(null); // Reset error state if the value is valid
        }
    };

    const handleHospitalBranch = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        dispatch(setLoggedInHospitalBranch(event.target.value));
    };
    const handlePincodeChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const value = event.target.value;
        // Allow only numbers (0-9)
        if (/^\d*$/.test(value) && value.length <= PINCODE_MAXIMUM_LENGTH) {
            setPincode(value);
        }
        // dispatch(setPincode(event.target.value));
    };
    const [isEditMode, setIsEditMode] = useState({
        name: false,
        email: false,
        mobileNumber: false,
        addressOne: false,
        hospitalBranch: false,
        hospitalName: false,
        gstNo: false,
        city: false,
        addressTwo: false,
        state: false,
        country: false,
        pincode: false,
    });
    const handleEditClick = (field: EditModeFields) => {
        setIsEditMode((prevState) => ({
            ...prevState,
            [field]: true,
        }));
    };

    const handleSubmit = async (event: React.SyntheticEvent) => {
        event.preventDefault();
        // console.log("submit");
        try {
            // setIsLoading(true);
            const userAttributes = [
                {
                    Name: 'custom:mobile_number',
                    Value: mobilenumber,
                },
                {
                    Name: 'custom:name',
                    Value: userName,
                },
            ];

            const LogoNameUuid = filename
                ? addUUIDSegmentToFilename(filename)
                : '';

            await adminUpdateUser(loggedInUserCognitoUuid, userAttributes);
            if (userRole.toLowerCase() === ADMIN.toLowerCase()) {
                let superAttributeNames: { [key: string]: string } = {
                    '#name': 'name',
                    // '#email': 'email',
                    '#profile_image_name': 'profile_image_name',
                    '#modified_by': 'modified_by',
                    '#modified_at': 'modified_at',
                };

                let superAttributeValues: { [key: string]: { S: string } } = {
                    ':name': { S: userName },
                    // ':email': { S: loggedInUserEmail },
                    ':profile_image_name': { S: LogoNameUuid },
                    ':modified_by': { S: loggedInUserTenantID },
                    ':modified_at': { S: formattedDateTime },
                    // ":tenant_id": { S: tenantUuid },
                };

                let superUpdateExpression =
                    'SET #name = :name, #profile_image_name = :profile_image_name, #modified_by = :modified_by, #modified_at = :modified_at';
                if (profilePictureName) {
                    if (oldProfileImageName) {
                        await deleteS3Object(oldProfileImageName);
                    }
                    await handleUpload(LogoNameUuid);
                }
                await updateUser(
                    USER_INFO_TABLE,
                    userTableUuid,
                    superAttributeNames,
                    superAttributeValues,
                    superUpdateExpression
                );
                dispatch(setProfileImageUrl(profilePictureUrl));
                dispatch(setLoggedInUserName(userName));
            } else {
                let attributeNames: { [key: string]: string } = {
                    '#name': 'name',
                    '#address1': 'address1',
                    '#address2': 'address2',
                    '#city': 'city',
                    '#email': 'email',
                    '#mobile_number': 'mobile_number',
                    '#state': 'state',
                    '#country': 'country',
                    '#pincode': 'pincode',
                    '#profile_image_name': 'profile_image_name',
                    '#modified_by': 'modified_by',
                    '#modified_at': 'modified_at',
                };

                let attributeValues: { [key: string]: { S: string } } = {
                    ':name': { S: userName },
                    ':email': { S: userEmail },
                    ':mobile_number': { S: mobilenumber },
                    ':address1': { S: addressOne },
                    ':address2': { S: addressTwo },
                    ':city': { S: city },
                    ':state': { S: userState },
                    ':country': { S: userCountry },
                    ':pincode': { S: pincode },
                    ':profile_image_name': { S: LogoNameUuid },
                    ':modified_by': { S: loggedInUserTenantID },
                    ':modified_at': { S: formattedDateTime },
                    // ":tenant_id": { S: tenantUuid },
                };

                let updateExpression =
                    'SET #name = :name, #email = :email, #mobile_number = :mobile_number, #address1 = :address1, #address2 = :address2, #city = :city, #state = :state, #country = :country, #pincode = :pincode, #profile_image_name = :profile_image_name, #modified_by = :modified_by, #modified_at = :modified_at';
                if (profilePictureName) {
                    if (oldProfileImageName) {
                        await deleteS3Object(oldProfileImageName);
                    }
                    await handleUpload(LogoNameUuid);
                }

                if (userRole.toLowerCase() === HOSPITAL.toLowerCase()) {
                    const hospitalAttrabutiesNames = {
                        '#name': 'name',
                        '#address1': 'address1',
                        '#address2': 'address2',
                        '#city': 'city',
                        '#state': 'state',
                        '#country': 'country',
                        '#pincode': 'pincode',
                        '#modified_by': 'modified_by',
                        '#modified_at': 'modified_at',
                        '#hospital_branch': 'hospital_branch',
                        '#hospital_name': 'hospital_name',
                        '#gst': 'gst',
                        '#profile_image_name': 'profile_image_name',
                    };

                    const hospitalAttributValues = {
                        ':name': { S: userName },
                        ':address1': { S: addressOne },
                        ':address2': { S: addressTwo },
                        ':city': { S: city },
                        ':state': { S: userState },
                        ':country': { S: userCountry },
                        ':pincode': { S: pincode },
                        ':hospital_branch': { S: loggedInHospitalBranch },
                        ':hospital_name': { S: hospitalName },
                        ':gst': { S: hospitalGstNo },
                        ':modified_at': { S: formattedDateTime },
                        ':modified_by': { S: loggedInUserTenantID },
                        ':profile_image_name': { S: LogoNameUuid },
                        //":tenant_id": { S: tenantUuid },
                    };

                    const hospitalUpdateExpression =
                        'SET #name = :name, #address1 = :address1, #address2 = :address2, #city = :city, #state = :state, #country = :country, #pincode = :pincode,  #modified_by = :modified_by, #modified_at = :modified_at, #hospital_branch = :hospital_branch,  #hospital_name = :hospital_name,#gst = :gst ,#profile_image_name = :profile_image_name';
                    if (profilePictureName) {
                        if (oldProfileImageName) {
                            await deleteS3Object(oldProfileImageName);
                        }
                        await handleUpload(LogoNameUuid);
                    }
                    await updateUser(
                        HOSPITAL_INFO_TABLE,
                        hospitalTableUuid,
                        hospitalAttrabutiesNames,
                        hospitalAttributValues,
                        hospitalUpdateExpression
                    );
                    const hospitalsAttrabutiesNames = {
                        '#modified_by': 'modified_by',
                        '#modified_at': 'modified_at',
                        '#hospital_name': 'hospital_name',
                        '#profile_image_name': 'profile_image_name',
                        '#gst': 'gst',
                    };

                    const hospitalsAttributValues = {
                        ':hospital_name': { S: hospitalName },
                        ':gst': { S: hospitalGstNo },
                        ':modified_at': { S: formattedDateTime },
                        ':modified_by': { S: loggedInUserTenantID },
                        ':profile_image_name': { S: LogoNameUuid },
                    };

                    const hospitalsUpdateExpression =
                        'SET  #modified_by = :modified_by, #modified_at = :modified_at, #hospital_name = :hospital_name,#gst = :gst,#profile_image_name = :profile_image_name';
                    if (profilePictureName) {
                        if (oldProfileImageName) {
                            await deleteS3Object(oldProfileImageName);
                        }
                        await handleUpload(LogoNameUuid);
                    }
                    await updateUser(
                        HOSPITALS_TABLE,
                        loggedInHospitalUuId,
                        hospitalsAttrabutiesNames,
                        hospitalsAttributValues,
                        hospitalsUpdateExpression
                    );
                    dispatch(setLoggedInUserName(userName));
                    dispatch(setLoggedInUserAddressOne(addressOne));
                    dispatch(setLoggedInUserAddressTwo(addressTwo));
                    dispatch(setLoggedInUserCity(city));
                    dispatch(setLoggedInUserCountry(userCountry));
                    dispatch(setLoggedInUserDeviceID(deviceID));
                    dispatch(setLoggedInUserPincode(pincode));
                    dispatch(setLoggedInUserState(userState));
                    dispatch(setLoggedInUserMobileNumber(mobilenumber));
                    dispatch(setLoggedInHospitalGstNo(hospitalGstNo));
                    dispatch(setLoggedInHospitalName(hospitalName));
                    dispatch(setProfileImageUrl(profilePictureUrl));
                }
                await updateUser(
                    USER_INFO_TABLE,
                    userTableUuid,
                    attributeNames,
                    attributeValues,
                    updateExpression
                );
                dispatch(setProfileImageUrl(profilePictureUrl));
                dispatch(setLoggedInUserName(userName));
                dispatch(setLoggedInUserAddressOne(addressOne));
                dispatch(setLoggedInUserAddressTwo(addressTwo));
                dispatch(setLoggedInUserCity(city));
                dispatch(setLoggedInUserCountry(userCountry));
                dispatch(setLoggedInUserDeviceID(deviceID));
                dispatch(setLoggedInUserPincode(pincode));
                dispatch(setLoggedInUserState(userState));
                dispatch(setLoggedInUserMobileNumber(mobilenumber));
            }
            MySwal.fire({
                position: 'top-end', // Position the toast in the top-right corner
                icon: 'success',
                title: 'Profile data saved successfully',
                showConfirmButton: false,
                timer: 1500,
                toast: true,
                customClass: {
                    popup: 'text-green bg-light_green', // Add custom class to the popup
                },
            });
        } catch (error: any) {
            let errorMessage;
            switch (error.name) {
                case 'UserNotFoundException':
                    errorMessage = 'User not found.';
                    break;
                case 'UsernameExistsException':
                    errorMessage = 'Username already exists.';
                    break;
                case 'InvalidParameterException':
                    errorMessage = 'Invalid parameters provided.';
                    break;
                case 'LimitExceededException':
                    errorMessage = 'Limit exceeded.';
                    break;
                case 'InternalErrorException':
                    errorMessage = 'Internal server error.';
                    break;
                default:
                    errorMessage =
                        error.message || 'An unknown error occurred.';
            }
            setError(errorMessage);
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];
        if (event.target.files && file) {
            validateFile(file);
            // dispatch(setHospitalLogo(file));
        }
    };

    const clearFileInput = () => {
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
        setFileName(null);
    };
    const validateFile = (file: File) => {
        const validTypes = ['image/png', 'image/jpeg', 'image/jpg'];
        const maxSizeInBytes = 50 * 1024; // 50KB
        const fileNameWithUnderscores = file.name.replace(/ /g, '_');
        // setFileName(fileNameWithUnderscores);

        if (!validTypes.includes(file.type)) {
            setErrorMessage(
                'Invalid file type. Only PNG, JPEG, and JPG are allowed.'
            );
            clearFileInput();
            return;
        }

        if (file.size > maxSizeInBytes) {
            setErrorMessage('File size exceeds 50KB.');
            clearFileInput();
            return;
        }

        setErrorMessage(null);
        const reader = new FileReader();
        reader.onloadend = () => {
            // console.log('reader.result as string', reader.result as string);
            setFileName(fileNameWithUnderscores);
            setProfilePictureName(fileNameWithUnderscores);
            setProfilePictureUrl(reader.result as string);
            setProfilePictureType(file.type);
        };
        reader.readAsDataURL(file);
    };
    const handleUploadClick = () => {
        // event.preventDefault();
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };
    const handleUpload = async (LogoNameUuid: string) => {
        if (!profilePictureUrl) {
            // alert('Please select a file first!');
            return;
        }
        const name = LogoNameUuid;
        // const content = data.logoUrl;
        const content = profilePictureUrl.split(',')[1]; // Get the base64 part
        // const buffer = Buffer.from(content, 'base64');
        // console.log('buffer', buffer)
        let buffer;
        try {
            const binaryString = atob(content);
            const length = binaryString.length;
            buffer = new Uint8Array(length);
            for (let i = 0; i < length; i++) {
                buffer[i] = binaryString.charCodeAt(i);
            }
        } catch (bufferError) {
            console.error('Error converting base64 to buffer:', bufferError);
            return;
        }
        const type = profilePictureType;
        const params = {
            Bucket: 'dripsetapplicationstaging',
            Key: name,
            Body: buffer,
            ContentType: type,
            ACL: ObjectCannedACL.private,
        };
        try {
            const command = new PutObjectCommand(params);
            const uploadResult = await s3Client.send(command);
            // console.log('File uploaded successfully:', uploadResult);
        } catch (error: any) {
            let errorMessage =
                'There was an error uploading the file. Please try again later.';

            switch (error.name) {
                case 'NoSuchBucket':
                    errorMessage = 'The specified bucket does not exist.';

                    break;
                case 'AccessDenied':
                    errorMessage = 'Access denied.';

                    break;
                case 'InvalidParameterException':
                    errorMessage =
                        'Invalid parameters. Please check the file details and try again.';
                    break;
                case 'NetworkingError':
                    errorMessage =
                        'Network error. Please check your internet connection and try again.';
                    break;
                default:
                    errorMessage =
                        error.message || 'Unexpected error occurred.';
            }

            setError(errorMessage);
        }
    };

    return (
        <div>
            <div className="flex align-items-center justify-content-between">
                <div className="font-bold text-base text-black">
                    <div
                        className="flex items-center cursor-pointer"
                        onClick={onBackClick}
                    >
                        <FaArrowLeftLong className="cursor-pointer" />{' '}
                        <h5 className="font-semibold ml-2">
                            {t('profile.back')}
                        </h5>
                    </div>
                </div>
                <div
                    className="mr-5 cursor-pointer"
                    onClick={handleChangePassword}
                >
                    <button className="py-2 px-3 text-primary rounded-xl border-2 border-primary bg-white">
                        {t('profile.change_password')}
                    </button>
                </div>
            </div>
            <div className="cart relative mx-auto bg-white rounded-2xl p-4 mt-5 lg:w-[80%] 2xl:w-[65%] lx:w-[460px]">
                {error && (
                    <div className="text-red-500 text-center">{error}</div>
                )}
                <form className="w-full mx-auto" onSubmit={handleSubmit}>
                    {error && (
                        <div className="w-max mx-auto">
                            <ErrorMessage message={error} />
                        </div>
                    )}
                    <div className="flex justify-start">
                        {/* <div className="w-2/4 mr-8"> */}
                        {/* {(userRole.toLowerCase() ==
                                INDIVIDUAL.toLowerCase() ||
                                userRole.toLowerCase() == NURSE.toLowerCase() ||
                                userRole.toLowerCase() ==
                                    HOSPITAL.toLowerCase()) && (
                                <>
                                    <label
                                        htmlFor="inputField"
                                        className="mt-2 mb-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.device_id')}
                                    </label>
                                    <input
                                        type="text"
                                        id="device_id"
                                        name="device_id"
                                        value={deviceID}
                                        placeholder="APOZ011"
                                        className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                        disabled
                                        readOnly
                                    />
                                </>
                            )} */}
                        {/* {userRole.toLowerCase() == ADMIN.toLowerCase() && (
                                <>
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.email_id')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="email_id"
                                            name="email_id"
                                            value={userEmail}
                                            onChange={handleEmailChange}
                                            placeholder="Dinesh651@gmail.com"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled
                                            readOnly
                                        />
                                    </div>
                                </>
                            )} */}
                        {/* </div> */}
                        <div className="w-2/4 mr-8">
                            {userRole.toLowerCase() ==
                            HOSPITAL.toLowerCase() ? (
                                <>
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.hospital_name')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="hospital_name"
                                            name="hospital_name"
                                            value={hospitalName}
                                            onChange={handleHospitalName}
                                            placeholder="Appolo Hospital"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled={!isEditMode.hospitalName}
                                            minLength={NAME_TEXT_MIN_LENGTH}
                                            title={HOSPITAL_NAME_TEXT_TITLE}
                                            pattern={HOSPITAL_NAME_PATTERN}
                                            maxLength={NAME_TEXT_MAX_LENGTH}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('hospitalName')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <label
                                        htmlFor="inputField"
                                        className="mt-2 mb-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.name')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={userName}
                                            onChange={handleUserNameChange}
                                            placeholder="Ramesh"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled={!isEditMode.name}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('name')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                        <div className="w-2/4">
                            {userRole.toLowerCase() == ADMIN.toLowerCase() ? (
                                <>
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.email_id')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="email_id"
                                            name="email_id"
                                            value={userEmail}
                                            onChange={handleEmailChange}
                                            placeholder="Dinesh651@gmail.com"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled
                                            readOnly
                                        />
                                    </div>
                                </>
                            ) : userRole.toLowerCase() == NURSE.toLowerCase() ? (
                                <>
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.hospital_name')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="hospital_name_nurse"
                                            name="hospital_name_nurse"
                                            value={loggedInHospitalName}
                                            placeholder="Hospital Name"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled
                                            readOnly
                                        />
                                    </div>
                                </>
                            ) : (
                                <>
                                    <label
                                        htmlFor="address_1"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.address_1_label')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <textarea
                                            name="address_1"
                                            id="address_1"
                                            value={addressOne}
                                            onChange={handleAddressOneChange}
                                            className="form-control px-3 py-2 placeholder-gains_boro"
                                            placeholder={t(
                                                'auth.signup.address_2_palceholder'
                                            )}
                                            maxLength={ADDRESS_MAX_LENGTH}
                                            disabled={!isEditMode.addressOne}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('addressOne')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                    {userRole.toLowerCase() == NURSE.toLowerCase() && (
                        <>
                            <div className="flex justify-start">
                                <div className="w-2/4 mr-8">
                                    <label
                                        htmlFor="hospital_id"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.hospital_id')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="hospital_id"
                                            name="hospital_id"
                                            value={loggedInHospitalId?.toUpperCase() || ''}
                                            placeholder="Hospital ID"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled
                                            readOnly
                                        />
                                    </div>
                                </div>
                                <div className="w-2/4">
                                    <label
                                        htmlFor="address_1"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.address_1_label')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <textarea
                                            name="address_1"
                                            id="address_1"
                                            value={addressOne}
                                            onChange={handleAddressOneChange}
                                            className="form-control px-3 py-2 placeholder-gains_boro"
                                            placeholder={t(
                                                'auth.signup.address_2_palceholder'
                                            )}
                                            maxLength={ADDRESS_MAX_LENGTH}
                                            disabled={!isEditMode.addressOne}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('addressOne')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    {/* {userRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                        <>
                            <div className="flex justify-start">
                                <div className="w-2/4 mr-8">
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.hospital_branch_label')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="hospital_branch"
                                            name="hospital_branch"
                                            value={loggedInHospitalBranch}
                                            onChange={handleHospitalBranch}
                                            placeholder="Anna Nager, chennai"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled={
                                                !isEditMode.hospitalBranch
                                            }
                                            maxLength={75}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick(
                                                    'hospitalBranch'
                                                )
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                                <div className="w-2/4">
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.gst_no')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="gst_no"
                                            name="gst_no"
                                            value={loggedInHospitalGstNo}
                                            onChange={handleHospitalGstChange}
                                            placeholder="33AGNGG66695SE8Z9"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            maxLength={GST_NUMBER_MAX_LENGTH}
                                            minLength={GST_NUMBER_MIN_LENGTH}
                                            title={GST_NUMBER_TITLE}
                                            disabled={!isEditMode.gstNo}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('gstNo')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </>
                    )} */}

                    {(userRole.toLowerCase() == INDIVIDUAL.toLowerCase() ||
                        userRole.toLowerCase() == NURSE.toLowerCase() ||
                        userRole.toLowerCase() == HOSPITAL.toLowerCase()) && (
                        <>
                            <div className="flex justify-start">
                                <div className="w-2/4 mr-8">
                                    <label
                                        htmlFor="address_2"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.address_2_label')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <textarea
                                            name="address_2"
                                            id="address_2"
                                            value={addressTwo}
                                            onChange={handleAddressTwoChange}
                                            className="form-control px-3 py-2 placeholder-gains_boro"
                                            placeholder={t(
                                                'auth.signup.address_2_palceholder'
                                            )}
                                            maxLength={ADDRESS_MAX_LENGTH}
                                            disabled={!isEditMode.addressTwo}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('addressTwo')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                                <div className="w-2/4">
                                    <label
                                        htmlFor="city"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.city')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            name="city"
                                            id="city"
                                            value={city}
                                            onChange={handleCityChange}
                                            className="form-control px-3 py-2 placeholder-gains_boro"
                                            placeholder={t(
                                                'auth.signup.city_placeholder'
                                            )}
                                            maxLength={NAME_TEXT_MAX_LENGTH}
                                            disabled={!isEditMode.city}
                                            required
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('city')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-start">
                                <div className="w-2/4 mr-8">
                                    <label
                                        htmlFor="country"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.country')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <select
                                            name="country"
                                            id="country"
                                            value={userCountry}
                                            onChange={handleCountryChange}
                                            className="w-full px-3 py-[0.65rem] border rounded placeholder-gains_boro focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent"
                                            required
                                            disabled={!isEditMode.country}
                                        >
                                            <option
                                                className="placeholder-gains_boro"
                                                value=""
                                                disabled
                                            >
                                                {t(
                                                    'auth.signup.country_placeholder'
                                                )}
                                            </option>
                                            {countryList.map((country) => (
                                                <option
                                                    key={country.code}
                                                    value={country.name}
                                                >
                                                    {country.name}
                                                </option>
                                            ))}
                                        </select>
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('country')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                                <div className="w-2/4">
                                    <label
                                        htmlFor="state"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.state')}
                                    </label>

                                    <div className="flex relative items-center">
                                        <select
                                            name="state"
                                            id="state"
                                            value={userState}
                                            onChange={handleStateChange}
                                            className="w-full px-3 py-[0.65rem] border rounded placeholder-gains_boro focus:outline-none focus:ring-1 focus:ring-primary focus:border-transparent"
                                            required
                                            disabled={!isEditMode.state}
                                        >
                                            <option value="" disabled>
                                                {t(
                                                    'auth.signup.state_placeholder'
                                                )}
                                            </option>
                                            {stateList.map((state) => (
                                                <option
                                                    key={state.id}
                                                    value={state.name}
                                                >
                                                    {state.name}
                                                </option>
                                            ))}
                                        </select>
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('state')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="flex justify-start">
                                <div className="w-2/4 mr-8">
                                    <label
                                        htmlFor="pincode"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.pincode_label')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            name="pincode"
                                            id="pincode"
                                            value={pincode}
                                            onChange={handlePincodeChange}
                                            className="form-control px-3 py-2 placeholder-gains_boro"
                                            placeholder={t(
                                                'auth.signup.address_2_palceholder'
                                            )}
                                            minLength={PINCODE_MINIMUM_LENGTH}
                                            maxLength={PINCODE_MAXIMUM_LENGTH}
                                            pattern={PINCODE_PATTERN}
                                            title={PINCODE_TITLE}
                                            required
                                            disabled={!isEditMode.pincode}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('pincode')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                                <div className="w-2/4">
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.email_id')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="email_id"
                                            name="email_id"
                                            value={userEmail}
                                            onChange={handleEmailChange}
                                            placeholder="Dinesh651@gmail.com"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            disabled
                                            readOnly
                                        />
                                        {/* <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('email')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button> */}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                    <div className="flex justify-start">
                        {(userRole.toLowerCase() == INDIVIDUAL.toLowerCase() ||
                            userRole.toLowerCase() == NURSE.toLowerCase() ||
                            userRole.toLowerCase() ==
                                HOSPITAL.toLowerCase()) && (
                            <>
                                <div className="w-2/4 mr-8">
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 mt-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.mobile_no')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            className="pl-10 form-control pr-3 py-2 my-2 placeholder-gains_boro w-full"
                                            type="text"
                                            name="mobile_number"
                                            id="mobile_number"
                                            value={mobilenumber}
                                            onChange={handleMobileNumberChange}
                                            placeholder="987654321"
                                            minLength={MOBILE_NUMBER_MIN_LENGTH}
                                            maxLength={MOBILE_NUMBER_MAX_LENGTH}
                                            pattern={MOBILE_NUMBER_PATTERN}
                                            title={MOBILE_NUMBER_TITLE}
                                            required
                                            disabled={!isEditMode.mobileNumber}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('mobileNumber')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                        <span className="absolute top-4 pl-3 cursor-pointer text-sm text-center">
                                            +91
                                        </span>
                                    </div>
                                </div>
                                <div className="w-2/4">
                                    <label
                                        htmlFor="profileLogo"
                                        className="block mb-2 text-sm font-medium text-label"
                                    >
                                        {t('profile.upload_profile_label')}
                                        {/* <span className="text-red ml-2">*</span> */}
                                    </label>
                                    <input
                                        type="file"
                                        name="profileLogo"
                                        aria-label="profileLogo"
                                        id="profileLogo"
                                        accept=".png, .jpeg, .jpg"
                                        onChange={handleFileChange}
                                        ref={fileInputRef}
                                        className="hidden"
                                    />
                                    <div className="flex items-center w-28 ">
                                        <div
                                            className="text-white !bg-primary font-medium text-sm  px-4 py-2 rounded cursor-pointer text-center"
                                            onClick={handleUploadClick}
                                        >
                                            {t('auth.signup.upload')}
                                        </div>
                                        <div className="text-base font-medium text-light_grey ml-2">
                                            {filename}
                                        </div>
                                    </div>
                                    <span className="text-xs font-normal text-light_grey">
                                        {t('auth.signup.logo_msg')}
                                    </span>
                                    {errorMessage && (
                                        <div className="text-danger my-2">
                                            {errorMessage}
                                        </div>
                                    )}
                                </div>
                            </>
                        )}
                    </div>
                    <div className="flex justify-start mt-4">
                        {userRole.toLowerCase() == ADMIN.toLowerCase() && (
                            <div className="w-2/4 mr-8">
                                <label
                                    htmlFor="profileLogo"
                                    className="block mb-2 text-sm font-medium text-label"
                                >
                                    {t('profile.upload_profile_label')}
                                    {/* <span className="text-red ml-2">*</span> */}
                                </label>
                                <input
                                    type="file"
                                    name="profileLogo"
                                    aria-label="profileLogo"
                                    id="profileLogo"
                                    accept=".png, .jpeg, .jpg"
                                    onChange={handleFileChange}
                                    ref={fileInputRef}
                                    className="hidden"
                                />
                                <div className="flex items-center w-28 ">
                                    <div
                                        className="text-white !bg-primary font-medium text-sm  px-4 py-2 rounded cursor-pointer text-center"
                                        onClick={handleUploadClick}
                                    >
                                        {t('auth.signup.upload')}
                                    </div>
                                    <div className="text-base font-medium text-light_grey ml-2">
                                        {filename}
                                    </div>
                                </div>
                                <span className="text-xs font-normal text-light_grey">
                                    {t('auth.signup.logo_msg')}
                                </span>
                                {errorMessage && (
                                    <div className="text-danger my-2">
                                        {errorMessage}
                                    </div>
                                )}
                            </div>
                        )}
                        {userRole.toLowerCase() == HOSPITAL.toLowerCase() && (
                            <>
                                <div className="w-[48%]">
                                    <label
                                        htmlFor="inputField"
                                        className="mb-2 text-sm font-medium text-light_grey"
                                    >
                                        {t('profile.gst_no')}
                                    </label>
                                    <div className="flex relative items-center">
                                        <input
                                            type="text"
                                            id="gst_no"
                                            name="gst_no"
                                            value={hospitalGstNo}
                                            onChange={handleHospitalGstChange}
                                            placeholder="Enter your GST Number"
                                            className="form-control px-3 py-2 my-2 placeholder-gains_boro w-full"
                                            maxLength={GST_NUMBER_MAX_LENGTH}
                                            minLength={GST_NUMBER_MIN_LENGTH}
                                            title={GST_NUMBER_TITLE}
                                            disabled={!isEditMode.gstNo}
                                        />
                                        <button
                                            type="button"
                                            className="absolute right-0 mx-2 rounded-md p-1 cursor-pointer"
                                            onClick={() =>
                                                handleEditClick('gstNo')
                                            }
                                            aria-label="edit-btn"
                                        >
                                            <MdOutlineModeEdit className="text-black" />
                                        </button>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>

                    <div className="w-2/5 mx-auto mt-2 flex justify-content-center cursor-pointer">
                        {isLoading ? (
                            <div className="btn !bg-primary text-white text-base font-medium py-2.5 mt-4 w-full">
                                <div>
                                    <LoadingSpinner className="text-secondary" />
                                </div>
                            </div>
                        ) : (
                            <button
                                type="submit"
                                className="text-white py-2 px-3 bg-primary w-full rounded"
                            >
                                {t('profile.save')}
                            </button>
                        )}
                    </div>
                </form>
            </div>
        </div>
    );
};
export default Profile;
